const ROUTE_NAMES = {
  HOME: 'home',
  ABOUT: 'about',
  LISTING_DETAILS: 'listing-details',
  ALTERNATIVES: 'alternatives',
  REVIEWS: 'reviews',
  REVIEWS_SINGLE: 'reviews-single',
  COMPARE: 'compare',
  RESOURCES: 'resources',
  RESOURCES_ALL: 'resources-all',
  RESOURCES_TOPIC: 'resources-topic',
  RESOURCES_TOPICS_INDEX: 'resources-topics-index',
  RESOURCES_POST: 'resources-post',
  RESOURCES_AUTHOR: 'resources-author',
  SERP: 'serp',
  SERP_CL: 'serp-cl',
  SEM: 'sem',
  LISTING_SEM: 'sem-listing',
  BX_DIRECTORY_CATEGORY_LISTINGS: 'bx-directory-category-listings',
  LISTING_GUIDELINES: 'listing-guidelines',
  RESOURCES_SITEMAP_INDEX: 'sitemap-index-resources',
  RESOURCES_TOPICS_SITEMAP: 'sitemap-resources-topics',
  RESOURCES_AUTHORS_SITEMAP: 'sitemap-resources-authors',
  RESOURCES_POSTS_SITEMAP: 'sitemap-resources-posts',
  STATIC_PAGES_SITEMAP: 'sitemap-static-pages',
  EXCEPTION: 'exception',
  HUB: 'contentHub',
  PRICING: 'pricing',
  FEATURES: 'features',
  INTEGRATIONS: 'integrations',
  BROWSE: 'browse',
  NEXT_DATA: '_next/data',
  FULLTEXT: 'full-text',
  PROFILE: 'profile',
  PRESS: 'press',
  PRIVACY_POLICY: 'privacy-policy',
  PRIVACY_POLICY_PREVIEW: 'privacy-policy-preview',
  TERMS_OF_USE: 'terms-of-use',
  TOP_SMALL_BUSINESS: 'top-small-business-tools',
  TOP_FUTURE_WORKFORCE: 'top-future-workforce-tools',
  VENDOR_TERMS_OF_USE: 'vendor-terms-of-use',
  CATEGORY_LEADERS_METHODOLOGY: 'category-leaders-methodology',
  API_LAZY_POSTS: 'api-lazy-posts',
  API_HEALTH_CHECK: 'api-health-check',
  API_AC: 'api-ac',
  API_FILTER_POSTS_BY_TOPIC: 'api-filter-posts-by-topic',
  API_ALTERNATIVES_SOFT_FILTERING: 'api-alternatives-soft-filtering',
  API_REVIEWS_SOFT_FILTERING: 'api-reviews-soft-filtering',
  API_RESOURCES_SEARCH: 'api-resources-search',
  API_SEND_LD_METRICS: 'api-send-ld-metrics',
  API_G2_COMPANY_LOOKUP: 'api-g2-company-lookup',
  API_FILTER_INTEGRATIONS: 'api-filter-integrations',
  API_SINGLE_REVIEW: 'api-single-review',
  API_BUYER_INTENT_EVENTS: 'api-buyer-intent-events',
  API_SOFT_FILTERING: 'api-soft-filtering',
  API_SIMILAR_ALTERNATIVES: 'api-similar-alternatives',
  API_HOME_CATEGORY_LISTINGS: 'api-home-category-listings',
  CONTENT_COMPLIANCE_POLICY: 'content-compliance-policy',
  CONTENT_COMPLIANCE_FAQS: 'content-compliance-faqs',
  GLOSSARY: 'glossary',
  COOKIE_SETTINGS: 'cookie-settings',
  COMMUNITY_GUIDELINES: 'community-guidelines',
  DATA_PROTECTION_AGREEMENT: 'data-protection-agreement',
  PPC_SERVICE_DESCRIPTION: 'ppc-service-description',
  PPL_SERVICE_DESCRIPTION: 'ppl-service-description',
  FREE_STUFF_ADDENDUM: 'free-stuff-addendum',
  DATA_PROCESSING_ADDENDUM: 'data-processing-addendum',
  DATA_TRANSFER_ADDENDUM: 'data-transfer-addendum',
  REVIEWS_FAQ: 'reviews-faq',
};

// ATTENTION - Trailing slashes are important for routing to work properly

const basic = [
  {
    name: ROUTE_NAMES.HOME,
    source: '',
  },
  {
    name: ROUTE_NAMES.ABOUT,
    source: '/about',
  },
  {
    name: ROUTE_NAMES.PRIVACY_POLICY,
    source: '/privacy_policy',
    destination: '/privacy_policy/',
  },
  {
    name: ROUTE_NAMES.PRIVACY_POLICY_PREVIEW,
    source: '/privacy_policy/preview',
    destination: '/privacy_policy/',
  },
  {
    name: ROUTE_NAMES.TERMS_OF_USE,
    source: '/terms_of_use',
    destination: '/terms_of_use/',
  },
  {
    name: ROUTE_NAMES.VENDOR_TERMS_OF_USE,
    source: '/vendor_terms_of_use',
    destination: '/vendor_terms_of_use/',
  },
  {
    name: ROUTE_NAMES.CATEGORY_LEADERS_METHODOLOGY,
    source: '/category-leaders-methodology',
    destination: '/category_leaders_methodology/',
  },
  {
    name: ROUTE_NAMES.LISTING_GUIDELINES,
    source: '/listing_guidelines',
    destination: '/listing_guidelines/',
  },
  {
    name: ROUTE_NAMES.CONTENT_COMPLIANCE_POLICY,
    source: '/content_compliance_policy',
    destination: '/content_compliance_policy/',
  },
  {
    name: ROUTE_NAMES.CONTENT_COMPLIANCE_FAQS,
    source: '/content_compliance_faqs',
    destination: '/content_compliance_faqs/',
  },
  {
    name: ROUTE_NAMES.REVIEWS_FAQ,
    source: '/reviews_faq',
    destination: '/reviews_faq/',
  },
  {
    name: ROUTE_NAMES.GLOSSARY,
    source: '/glossary',
    destination: '/glossary/',
  },
  {
    name: ROUTE_NAMES.COOKIE_SETTINGS,
    source: '/cookie_settings',
    destination: '/cookie_settings/',
  },
  {
    name: ROUTE_NAMES.COMMUNITY_GUIDELINES,
    source: '/community_guidelines',
    destination: '/community_guidelines/',
  },
  {
    name: ROUTE_NAMES.DATA_PROTECTION_AGREEMENT,
    source: '/data_protection_agreement',
    destination: '/data_protection_agreement/',
  },
  {
    name: ROUTE_NAMES.PPC_SERVICE_DESCRIPTION,
    source: '/ppc_service_description',
    destination: '/ppc_service_description/',
  },
  {
    name: ROUTE_NAMES.PPL_SERVICE_DESCRIPTION,
    source: '/ppl_service_description',
    destination: '/ppl_service_description/',
  },
  {
    name: ROUTE_NAMES.FREE_STUFF_ADDENDUM,
    source: '/free_stuff_addendum',
    destination: '/free_stuff_addendum/',
  },
  {
    name: ROUTE_NAMES.DATA_PROCESSING_ADDENDUM,
    source: '/data_processing_addendum',
    destination: '/data_processing_addendum/',
  },
  {
    name: ROUTE_NAMES.DATA_TRANSFER_ADDENDUM,
    source: '/data_transfer_addendum',
    destination: '/data_transfer_addendum/',
  },
];

const compare = [
  {
    name: ROUTE_NAMES.COMPARE,
    source: '/:header-software/a/:slug/compare/{:apps}?',
    destination: '/compare/',
  },
];

const listing = [
  {
    name: ROUTE_NAMES.LISTING_DETAILS,
    source: '/:header-software/a/:slug',
    destination: '/listingDetail/',
  },
  {
    name: ROUTE_NAMES.ALTERNATIVES,
    source: '/:header-software/a/:slug/alternatives',
    destination: '/alternatives/',
  },
];

const api = [
  {
    name: ROUTE_NAMES.API_HEALTH_CHECK,
    source: '/apiui/healthcheck',
    destination: '/api/healthcheck/',
  },
  { name: ROUTE_NAMES.API_AC, source: '/apiui/ac', destination: '/api/ac/' },
  {
    name: ROUTE_NAMES.API_LAZY_POSTS,
    source: '/apiui/lazyPosts',
    destination: '/api/lazyPosts/',
  },
  {
    name: ROUTE_NAMES.API_FILTER_POSTS_BY_TOPIC,
    source: '/apiui/filterPostsByTopic',
    destination: '/api/filterPostsByTopic/',
  },
  {
    name: ROUTE_NAMES.API_RESOURCES_SEARCH,
    source: '/apiui/resourcesSearch',
    destination: '/api/resourcesSearch/',
  },
  {
    name: ROUTE_NAMES.API_SEND_LD_METRICS,
    source: '/apiui/sendLDMetrics',
    destination: '/api/sendLDMetrics/',
  },
  {
    name: ROUTE_NAMES.API_G2_COMPANY_LOOKUP,
    source: '/apiui/g2CompanyLookup',
    destination: '/api/g2CompanyLookup/',
  },
  {
    name: ROUTE_NAMES.API_BUYER_INTENT_EVENTS,
    source: '/apiui/buyerIntent/events',
    destination: '/api/buyerIntent/events/',
  },
  {
    name: ROUTE_NAMES.API_ALTERNATIVES_SOFT_FILTERING,
    source: '/apiui/alternativesSoftFiltering',
    destination: '/api/alternativesSoftFiltering/',
  },
  {
    name: ROUTE_NAMES.API_SIMILAR_ALTERNATIVES,
    source: '/apiui/similarAlternatives',
    destination: '/api/similarAlternatives/',
  },
  {
    name: ROUTE_NAMES.API_HOME_CATEGORY_LISTINGS,
    source: '/apiui/home/category-listings',
    destination: '/api/home/category-listings/',
  },
];

const resources = [
  {
    name: ROUTE_NAMES.RESOURCES,
    source: '/resources',
    destination: '/resources/',
  },
  {
    name: ROUTE_NAMES.RESOURCES_ALL,
    source: '/resources/all',
  },
  {
    name: ROUTE_NAMES.RESOURCES_TOPICS_INDEX,
    source: '/resources/topics',
  },
  {
    name: ROUTE_NAMES.RESOURCES_POST,
    source: '/resources/:slug',
    destination: '/resources/post',
  },
  {
    name: ROUTE_NAMES.RESOURCES_TOPIC,
    source: '/resources/topic/:slug{/page-:page(\\w+)}?',
    destination: '/resources/topic/',
  },
  {
    name: ROUTE_NAMES.RESOURCES_AUTHOR,
    source: '/resources/author/:slug{/page-:page(\\w+)}?',
    destination: '/resources/author/',
  },
];

const serp = [
  {
    name: ROUTE_NAMES.SERP_CL,
    source: '/:header-software/:categorySlug/category-leaders',
    destination: '/categoryLeaders/',
  },
  {
    name: ROUTE_NAMES.SERP,
    source:
      '/:header-software/:categorySlug{/page-:pagination}?{/:facet(f|org|os|p|w)}?{/:filter}?',
    destination: '/serp/',
  },
  {
    name: ROUTE_NAMES.FULLTEXT,
    source: '/s/:query{/page-:pagination(\\w+)}?',
    destination: '/fullText/',
  },
  {
    name: ROUTE_NAMES.BX_DIRECTORY_CATEGORY_LISTINGS,
    source: '/bx_directory/:categorySlug/listings',
    destination: '/serp/bxCategoryListings',
  },
];

const sem = [
  {
    name: ROUTE_NAMES.LISTING_SEM,
    source: '/p/sem/a/:slug',
    destination: '/sem/listingDetail/',
  },
  {
    name: ROUTE_NAMES.SEM,
    source: '/p/sem/:categorySlug-software',
    destination: '/sem/serp',
  },
];

const sitemaps = Object.values({
  resources: [
    {
      name: ROUTE_NAMES.RESOURCES_SITEMAP_INDEX,
      source: '/sitemaps/resources/sitemap-index.xml',
      destination: '/sitemaps/resources/sitemap-index',
    },
    {
      name: ROUTE_NAMES.RESOURCES_POSTS_SITEMAP,
      source: '/sitemaps/resources/posts.xml',
      destination: '/sitemaps/resources/posts',
    },
    {
      name: ROUTE_NAMES.RESOURCES_TOPICS_SITEMAP,
      source: '/sitemaps/resources/topics.xml',
      destination: '/sitemaps/resources/topics',
    },
    {
      name: ROUTE_NAMES.RESOURCES_AUTHORS_SITEMAP,
      source: '/sitemaps/resources/authors.xml',
      destination: '/sitemaps/resources/authors',
    },
  ],
  static: [
    {
      name: ROUTE_NAMES.STATIC_PAGES_SITEMAP,
      source: '/sitemaps/static-pages.xml',
      destination: '/sitemaps/static-pages',
    },
  ],
}).flat(Number.POSITIVE_INFINITY);

const exception = [{ name: ROUTE_NAMES.EXCEPTION, source: '/exception' }];

const browse = [
  { name: ROUTE_NAMES.BROWSE, source: '/browse', destination: '/browse/' },
];

const hub = [
  {
    name: ROUTE_NAMES.HUB,
    source: '/knowledge-base/:slug',
    destination: '/contentHub/',
  },
];

const profile = [
  {
    name: ROUTE_NAMES.PROFILE,
    source: '/profile/me',
    destination: '/profile/',
  },
];

const press = [{ name: ROUTE_NAMES.PRESS, source: '/press' }];

const list = [
  ...basic,
  ...compare,
  ...listing,
  ...resources,
  ...hub,
  ...serp,
  ...api,
  ...sem,
  ...sitemaps,
  ...exception,
  ...browse,
  ...profile,
  ...press,
];

// ATTENTION - In case of issues - order matters
module.exports = {
  list: list,
  listWithDestination: list.filter((route) => route.destination),
  ROUTE_NAMES,
};
